// 全局路由钩子在这里定义(包括客户端路由鉴权)。服务端、客户端都会走这里
import { useStore } from '@/store';
import { useRouter } from 'vue-router';

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const store = useStore();
  let loadingFlag = false;
  let positionLength = 0;

  router.beforeEach((to, from, next) => {
    // INP
    if (process.client) {
      setTimeout(() => {
        try {
          positionLength = window.history.state.position;
        } catch (error) {
          positionLength = 0;
          console.error(error);
        }
        // 判断是否走强制更新 TODO 此部分逻辑后期可移入 middleware
        const forceUpdate = sessionStorage.getItem('voo_forceUpdate');
        if (forceUpdate === '1') {
          sessionStorage.setItem('voo_forceUpdate', '0');
          let href = `${window.location.origin}${to.fullPath}`;
          const t = Date.now();
          if (Object.keys(to.query).length > 0) {
            href = `${href}&t=${t}`;
          } else {
            href = `${href}?t=${t}`;
          }
          window.location.href = href;
          return;
        }

        // 采用延迟300ms出loading的方案
        loadingFlag = true;
        setTimeout(() => {
          if (loadingFlag) {
            // 暂时不在路由文件加载期间显示loading
            // nuxtApp.$loadingShow();
          }
        }, 300);
        next();
      }, 20);
    } else {
      next();
    }
  });

  router.afterEach(async (to, from) => {
    if (process.client) {
      try {
        const newLength = window.history.state.position;
        store.UPDATE_IS_ROUTER_PUSH(positionLength ? newLength > positionLength : true);
      } catch (error) {
        console.error(error);
        store.UPDATE_IS_ROUTER_PUSH(true);
      }
      loadingFlag = false;

      // gtag / Consent / GA 由 layouts/default.vue 的 useGtagConsentInit（watch route.name）统一处理
      // 暂时不在路由文件加载期间显示loading
      // nuxtApp.$loadingHide() // 这里取消loading，app.vue中的suspense有另外一套loading。后期考虑优化成1套。
    }
  });
});
